import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewComponent} from './view.component';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {ComponentsModule} from '../../components/components.module';
import {ExportComponent} from './export/export.component';
import {PanelModule} from 'primeng/panel';
import {ButtonModule} from 'primeng/button';
import {TableDataModule} from '../../components/table-data/table-data.module';
import {TagModule} from "primeng/tag";
import {SelectButtonModule} from "primeng/selectbutton";
import {DialogModule} from "primeng/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {CheckboxModule} from "primeng/checkbox";
import {MessageModule} from "primeng/message";
import {TableModule} from "primeng/table";
import {RippleModule} from "primeng/ripple";
import {TooltipModule} from "primeng/tooltip";
import {RouterLink} from "@angular/router";
import {BeautifulFilterComponent} from "../../components/filter/beautiful-filter/beautiful-filter.component";
import { PipesModule } from '../../pipes/pipes.module';
import {ToastModule} from "primeng/toast";

@NgModule({
    declarations: [ViewComponent, ExportComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        TooltipModule,
        DropdownModule,
        FormsModule,
        TableDataModule,
        PanelModule,
        ButtonModule,
        TagModule,
        SelectButtonModule,
        DialogModule,
        TranslateModule,
        CheckboxModule,
        MessageModule,
        TableModule,
        RippleModule,
        RouterLink,
        BeautifulFilterComponent,
        PipesModule,
        ToastModule
    ],
  exports: [ViewComponent]
})
export class ViewModule { }
